import {
  Container,
  Columns,
  Col,
  Heading,
  Text,
  Image,
} from '@redriverpress/system'

import { renderInlineMarkdown } from 'Common/utils/markdown'
import getInitialState from 'Common/utils/getInitialState'
import Breadcrumbs from 'Common/components/Breadcrumbs'

export default function CategoryHeader() {
  const { title, description, thumbnail, slug } = getInitialState()

  return (
    <>
      <Breadcrumbs
        routes={[
          {
            label: 'Collections',
            to: '/collections',
            external: true,
          },
          {
            label: title,
            to: slug,
            external: true,
          },
        ]}
      />
      <Container pt={[3, null, 4]} pb={[4, null, 5]}>
        <Columns alignItems='center'>
          <Col width={[1, null, 2 / 3]} order={[2, null, 1]}>
            <Heading mb={3}>{title}</Heading>
            {description && (
              <Text
                measure
                dangerouslySetInnerHTML={{
                  __html: renderInlineMarkdown(description || ''),
                }}
              />
            )}
          </Col>
          <Col
            width={[1, null, 1 / 3]}
            order={[1, null, 2]}
            textAlign={['left', null, 'center']}
          >
            {thumbnail && (
              <Image
                src={thumbnail}
                size={['10rem', null, '12rem', '15rem']}
                alt=''
              />
            )}
          </Col>
        </Columns>
      </Container>
    </>
  )
}
